import { render } from "./SearchMain.vue?vue&type=template&id=36370c76&scoped=true&ts=true"
import script from "./SearchMain.vue?vue&type=script&lang=ts"
export * from "./SearchMain.vue?vue&type=script&lang=ts"

import "./SearchMain.vue?vue&type=style&index=0&id=36370c76&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36370c76"]])

export default __exports__